<template>
	<div class="bx-page welcome">
		<div class="centered" style="max-width:400px;">
			<div class="bx-raised-more">
				<h1>👮‍♂️ Please Login</h1>
				<p class="callout-info s-below">No account? <router-link :to="{name:'Register'}">Create one here</router-link></p>
				<LoginForm />
			</div>
		</div>
	</div>
</template>


<script>

	import { unref } from "vue";
	import useAuthStore from "../../stores/AuthStore";
	import LoginForm from "../../components/LoginForm";

	export default {
		
		components:{
			LoginForm,
		},

		beforeRouteEnter (to, from, next) {
			var {is_logged_in,user} = useAuthStore();
			if(unref(is_logged_in) && user.is_super){
				next(to.query.redirect||{name:'Dashboard'});
			} else {
				next();
			}
		},

	}
</script>